import { useSearchPagePageSize } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPagePageSize";
import { useSearchPageProducts } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageProducts";
import { useMemo } from "react";
export var useSearchPageSlicedProducts = function() {
    var products = useSearchPageProducts();
    var pageSize = useSearchPagePageSize();
    return useMemo(function() {
        return products === null || products === void 0 ? void 0 : products.slice(0, pageSize);
    }, [
        pageSize,
        products
    ]);
};
